/**
 * 公共数据使用
 */
import type { RouterType, ModuleType } from '@/types/router'
import type { UserInfoType, AllMenuType } from '../types/common'

import { setSessionItem, getSessionItem, clearSession } from '@/utils/sessionstorage'
import { postSmslogin, postLogin, getUserPermissions } from '@/service/register/register'
import { setLocalItem, getLocalItem } from '@/utils/localStorage'
import router, { resetRouter, loginRouter } from '@/router'

const common = {
  namespaced: true,
  state: {
    token: getLocalItem('zl-user-token') || null,
    permissionRouter: null, // 有权限的路由信息
    whiteArrRouter: [
      '/login',
      '/404',
      '/adminRegister',
      '/userServiceAgreementr',
      '/accountOpenType',
      '/resetPassword',
      '/resetSuccess',
      '/about',
      '/confirmSheet',
      '/authJump'
    ], // 白名单路由信息
    allMenu: {}, // 所有路由信息
    navMenuArr: [], // 导航栏菜单
    sideMenuArr: [], // 侧边栏菜单
    sideStatus: true, // 左侧菜单展示状态
    sideMenuOther: {}, // 左侧菜单栏显示的其他数据信息 todos
    navActived: null || getSessionItem('zl-nav-actived'), // 导航栏当前选中的
    sideOpen: [], // 侧边栏打开的二级菜单
    sideActive: null || getSessionItem('zl-side-actived'), // 侧边栏默认选中的
    userInfo: null || getSessionItem('zl-user-info'), // 用户的信息
    permissionsObj: null || getSessionItem('zl-user-permission'), // 用户权限信息
    permissionsRouterObj: null || getSessionItem('zl-router-operate-permission'), // 路由页面按钮权限
    pageTitle: null, // 页面标题
    commonPDFObj: {
      用户服务协议: 'https://www.tzt.com.cn/media/tzt/agreement/众禄投资通网上交易服务协议.pdf',
      隐私保护条款: 'https://www.tzt.com.cn/media/tzt/agreement/隐私条款.pdf',
      风险揭示书: 'https://www.tzt.com.cn/media/tzt/agreement/风险提示.pdf',
      客户维护揭示书: 'https://www.tzt.com.cn/media/tzt/agreement/客户维护费揭示.pdf',
      投资者权益须知: 'https://www.tzt.com.cn/media/tzt/agreement/投资者权益须知.pdf',
      投资者适当性管理制度: 'https://www.tzt.com.cn/media/tzt/agreement/众禄基金投资者适当性管理指引.pdf',
      基金产品风险等级评价管理办法:
        'https://www.tzt.com.cn/media/tzt/agreement/众禄基金销售股份有限公司产品及服务风险等级评价方法.pdf',
      投诉建议: 'https://www.tzt.com.cn/media/tzt/agreement/投诉建议.pdf',
      免责声明: 'https://www.tzt.com.cn/media/tzt/agreement/免责声明.pdf'
    }, // 全局共用的PDF链接信息
    loadingText: '努力加载中...', // loading的展示内容
    confirmErrMsgObj: {
      show: false,
      content: ''
    }, // 错误确认信息弹框展示
    isRouterAlive: true, //
    useTheme: getSessionItem('zl-use-theme'), // 当前使用的主题
    httpLoading: false // 全局的loading
  },
  getters: {
    getPermissionRouter(state: { permissionRouter: RouterType[] }) {
      return state.permissionRouter
    },
    getWhileArrRouter(state: { whiteArrRouter: string[] }) {
      return state.whiteArrRouter
    },
    getAllMenu(state: { allMenu: AllMenuType }) {
      return state.allMenu
    },
    getNavMenuArr(state: { navMenuArr: ModuleType[] }) {
      return state.navMenuArr
    },
    getSideMenuArr(state: { sideMenuArr: RouterType[] }) {
      return state.sideMenuArr
    },
    getSideStatus(state: { sideStatus: boolean }) {
      return state.sideStatus
    },
    getUserInfo(state: { userInfo: UserInfoType }) {
      return state.userInfo || getSessionItem('zl-user-info')
    },
    getPermissionsObj(state: { permissionsObj: any }) {
      return state.permissionsObj || getSessionItem('zl-user-permission')
    },
    getpermissionsRouterObj(state: { permissionsRouterObj: any }) {
      return state.permissionsRouterObj || getSessionItem('zl-router-operate-permission')
    },
    getPagetTitle(state: { pageTitle: string }) {
      return state.pageTitle
    },
    getCommonPDFObj(state: { commonPDFObj: { string: string } }) {
      return state.commonPDFObj
    }
  },
  mutations: {
    SET_TOKEN(state: { token: string | null }, value: string) {
      state.token = value
      setLocalItem('zl-user-token', value)
    },
    PREMISSION_ROUTER(state: { permissionRouter: RouterType[] | null }, value: RouterType[]) {
      state.permissionRouter = value
    },
    ALL_MENU(state: { allMenu: AllMenuType }, value: AllMenuType) {
      state.allMenu = value
      setSessionItem('zl-nav-menu', value)
    },
    NAV_MENU_ARR(state: { navMenuArr: ModuleType[] }, value: ModuleType[]) {
      state.navMenuArr = value
    },
    NAV_ACTIVED(state: { navActived: string }, value: string) {
      state.navActived = value
      setSessionItem('zl-nav-actived', value)
    },
    // 左侧菜单列表信息
    SIDE_MENU_ARR(state: { sideMenuArr: RouterType[]; sideOpen: string[]; sideActive: string }, value: RouterType[]) {
      state.sideMenuArr = value
      if (Array.isArray(value) && value.length > 0) {
        // 判断是否有默认的路由 如果没有则获取路由的第一个
        const { name, children } = value[0]
        state.sideOpen = [name as string]
        // 默认进入的菜单
        const firstUrlName = getSessionItem('zl-side-actived')

        // 存在下级菜单获取下一级、 否则或者本身
        if (firstUrlName) {
          state.sideActive = firstUrlName
        } else if (Array.isArray(children) && children.length > 0) {
          // 判断是否还存在第下一层子级
          if (Array.isArray(children[0].children) && children[0].children.length > 0) {
            state.sideActive = children[0].children[0].name as string
          } else {
            state.sideActive = children[0].name as string
          }
        } else {
          state.sideActive = name as string
        }
      }
      // 侧边点击菜单
      setSessionItem('zl-side-actived', state.sideActive)
    },
    // 左侧菜单显示状态
    SIDE_STATUS(state: { sideStatus: boolean }, value: boolean) {
      state.sideStatus = value
    },
    // 左侧菜单该显示的数据信息
    SIDE_MENU_OTHER(state: { sideMenuOther: object }, value: object) {
      state.sideMenuOther = value
    },
    // 左侧选中的菜单信息
    SIDE_ACTIVE(state: { sideActive: string }, value: string) {
      state.sideActive = value
      setSessionItem('zl-side-actived', value)
    },
    USER_INFO(state: { userInfo: UserInfoType; token: string }, value: UserInfoType) {
      // 进入文件信息
      state.userInfo = value
      // 不保存用户权限的信息
      state.userInfo.permissionsSet = []
      state.userInfo.roles = []
      setSessionItem('zl-user-info', state.userInfo)
      // 判断数组
      const beforeUserList = JSON.parse(JSON.stringify(getLocalItem('zl-login-username'))) || []
      if (Array.isArray(beforeUserList)) {
        const index = beforeUserList.indexOf(value?.mobileno)
        if (index !== -1) {
          beforeUserList.splice(index, 1)
        }
        beforeUserList.push(value?.mobileno)
        // 保存当前用户登录的手机号
        setLocalItem('zl-login-username', [...new Set(beforeUserList)])
      } else {
        setLocalItem('zl-login-username', [beforeUserList])
      }

      state.token = `${value?.lastLogin}token${value?.id}`
      setLocalItem('zl-user-token', state.token)

      setSessionItem('zl-login-date', value?.lastLogin) // 获取接口返回的用户最后登录的服务器时间
    },
    PERMISSIONS_OBJ(state: { permissionsObj: any }, value: any) {
      state.permissionsObj = value
      setSessionItem('zl-user-permission', value)
    },
    PERMISSIONS_ROUTER_OBJ(state: { permissionsRouterObj: any }, value: any) {
      state.permissionsRouterObj = value
      setSessionItem('zl-router-operate-permission', value)
    },
    NEW_USER_INFO(state: { userInfo: UserInfoType }, value: UserInfoType) {
      // 进入文件信息
      state.userInfo = value
      setSessionItem('zl-user-info', state.userInfo)
    },
    PAGE_TITLE(state: { pageTitle: string }, value: string) {
      state.pageTitle = value
    },
    LOADING_TEXT(state: { loadingText: string }, value: string) {
      state.loadingText = value
    },
    CONFIEM_ERR_MSG_OBJ(
      state: { confirmErrMsgObj: { show: boolean; content: string } },
      value: { show: boolean; content: string }
    ) {
      Object.assign(state.confirmErrMsgObj, value)
    },
    IS_ROUTER_ALIVE(state: { isRouterAlive: boolean }, value: boolean) {
      state.isRouterAlive = value
    },
    HTTP_LOADING(state: { httpLoading: boolean }, value: boolean) {
      state.httpLoading = value
    },
    USE_THEME(state: { useTheme: string }, value: string) {
      state.useTheme = value
      setSessionItem('zl-use-theme', value)
    }
  },
  actions: {
    login(context: { commit: (arg0: string, arg1: any) => void; dispatch: any }, form: any) {
      return new Promise<void>((resolve, reject) => {
        if (form.activeType === 'phone') {
          postSmslogin(form.params)
            .then(async (res: any) => {
              const { data, code } = res
              if (code === 0) {
                context.dispatch('logout')
                context.commit('USER_INFO', {
                  investAcctType: data?.firstUnsubmitInvestAcctType,
                  ...data
                })
                context.commit('PREMISSION_ROUTER', null)
                setSessionItem('zl-login-now-date', new Date().getTime()) // 获取当前用户本地时间

                await context.dispatch('getPermissions')
              }
              resolve(res)
            })
            .catch((err: any) => {
              reject(err)
            })
        } else {
          postLogin(form.params)
            .then(async (res: any) => {
              const { data, code } = res
              if (code === 0) {
                context.dispatch('logout')
                context.commit('USER_INFO', data)
                context.commit('PREMISSION_ROUTER', null)
                setSessionItem('zl-login-now-date', new Date().getTime()) // 获取当前用户本地时间
                await context.dispatch('getPermissions')
              }

              resolve(res)
            })
            .catch((err: any) => {
              reject(err)
            })
        }
      })
    },
    getPermissions(context: any) {
      return new Promise<void>((resolve, reject) => {
        getUserPermissions({ userId: context.state.userInfo.id }).then((res) => {
          if (res.code === 0) {
            context.commit('PERMISSIONS_OBJ', res.data?.tzt)

            // 触发获取用户信息，并获取用户当前权限
            const filterRoutes = loginRouter()
            // 有权限路由数据进行存储
            context.commit('PREMISSION_ROUTER', filterRoutes)
            if (filterRoutes) {
              filterRoutes.forEach((item) => {
                router.addRoute(item)
              })
            }
          }
          resolve(res)
        })
      })
    },
    logout(context: { commit: (arg0: string, arg1: any) => void }, obj: any) {
      // 退出登录
      resetRouter()
      context.commit('SET_TOKEN', null)
      context.commit('PREMISSION_ROUTER', null)
      clearSession()
      if (!(obj || (obj && obj?.hideLoginPage))) {
        router.push('/login')
      }
    }
  }
}

export default common
